// A lion, modelled facing +X: a tawny body, a broad maned head and a tuft-tipped
// tail. Ported 1:1 from age-of-mcp's classic lion.ts, restoring its leg loop +
// body/mane/face/tail composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.06, 0.03], [0.06, -0.03], [-0.06, 0.03], [-0.06, -0.03]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.01, 0.009, 0.092, 4),
      color: "#b58a4e", position: [x!, 0.046, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#c89a52",
      position: [0, 0.092, 0], scale: [1.9, 1, 0.9] },               // body
    { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#7a4e22",
      position: [0.1, 0.1, 0], scale: [1.1, 1.1, 1.1] },             // mane
    { geometry: new THREE.IcosahedronGeometry(0.032, 0), color: "#d4a85e",
      position: [0.12, 0.1, 0] },                                    // face
    { geometry: new THREE.ConeGeometry(0.013, 0.026, 4), color: "#c89a52",
      position: [0.145, 0.094, 0], rotation: [0, 0, -Math.PI / 2] },   // muzzle
    { geometry: new THREE.CylinderGeometry(0.005, 0.005, 0.07, 4), color: "#b58a4e",
      position: [-0.1, 0.085, 0], rotation: [0, 0, 1.0] },          // tail
    { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#5a3a18",
      position: [-0.13, 0.11, 0] },                                  // tail tuft
  );
  return parts;
}

export const lion = defineModel({
  id: "lion",
  scale: 2.63, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Lion",
  tags: ["creature","lion","low-poly","age-of-mcp","classic"],
  summary: "Low-poly lion.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.15,
  parts: () => partsFor(),
  animations: [],
});
